import React from 'react';
import { Alert, Button, Stack } from '@mui/material';
import { LockOutlined, LoginOutlined, SpaceDashboardOutlined } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import AuthPageShell from './AuthPageShell';

const Unauthorized: React.FC = () => {
  const { user } = useAuth();
  const { t } = useLanguage();

  return (
    <AuthPageShell title={t('auth.accessDeniedTitle')} description={t('auth.accessDeniedDescription')} icon={<LockOutlined />}>
      <Alert severity="warning" sx={{ mb: 2 }}>{t('auth.accessDeniedHelp')}</Alert>
      <Stack spacing={1.25}>
        {user
          ? <Button component={Link} to="/dashboard" variant="contained" startIcon={<SpaceDashboardOutlined />} sx={{ minHeight: 48 }}>{t('dashboard.title')}</Button>
          : <Button component={Link} to="/login" variant="contained" startIcon={<LoginOutlined />} sx={{ minHeight: 48 }}>{t('auth.loginButton')}</Button>}
        <Button component={Link} to="/help" variant="outlined" sx={{ minHeight: 48 }}>{t('nav.help')}</Button>
      </Stack>
    </AuthPageShell>
  );
};

export default Unauthorized;
